import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { useSearchParams } from "@/hooks/router/use-search-params";
import { useIonRouter } from "@ionic/react";
import { MealPlan } from "../../../../pages/plans/types/meal-plan.type";

export const useSwapPlanData = () => {
  const router = useIonRouter();
  const searchParams = useSearchParams();

  const getSwapPlanRawData = (): string | null => {
    return localStorage.getItem(LocalStorageKeys.SWAP_PLAN_MEAL_DATA);
  };

  const getSwapPlanData = (): MealPlan | null => {
    const mealData = localStorage.getItem(LocalStorageKeys.SWAP_PLAN_MEAL_DATA);
    if (!mealData) {
      return null;
    }
    const decodedMealData = JSON.parse(mealData);
    console.log(
      "get mealPlan",
      decodedMealData.meal.id,
      decodedMealData.meal.name,
      decodedMealData.mealTime,
      decodedMealData.mealIndex,
      decodedMealData.mealDay,
    );
    return decodedMealData;
  };

  const onSwapClick = (
    mealPlan: MealPlan,
    { replace, searchParamJsonString }: { replace?: boolean; searchParamJsonString?: string } = {},
  ) => {
    console.log(
      "swap mealPlan",
      mealPlan.meal.id,
      mealPlan.meal.name,
      mealPlan.mealTime,
      mealPlan.mealIndex,
      mealPlan.mealDay,
    );
    const mealJson = JSON.stringify(mealPlan);
    localStorage.setItem(LocalStorageKeys.SWAP_PLAN_MEAL_DATA, mealJson);

    // Clear the index to set the default index to the selected meal in alternative meals
    localStorage.removeItem(LocalStorageKeys.SWAP_PLAN_MEAL_INDEX);

    console.log("searchParamJsonString", searchParamJsonString);
    const searchParamsJson =
      searchParamJsonString ?? JSON.stringify(Object.fromEntries(searchParams.entries()));
    console.log("searchParams", Object.fromEntries(searchParams.entries()));
    console.log("searchParamsJson", searchParamsJson);
    localStorage.setItem(LocalStorageKeys.SWAP_PLAN_SEARCH_PARAMS, searchParamsJson);

    router.push(`/plans/swap-plan`, "forward", replace ? "replace" : "push");
  };

  return {
    onSwapClick,
    getSwapPlanData,
    getSwapPlanRawData,
  };
};
